import { render } from "./AdvisorEmailTest.vue?vue&type=template&id=1b4f40a4"
import script from "./AdvisorEmailTest.vue?vue&type=script&lang=js"
export * from "./AdvisorEmailTest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__